import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { WHY } from "@/data/site";
import { SectionHeading } from "@/components/pp/Shared";

export default function WhyPixelPapad() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start center", "end center"] });
  const lineScale = useTransform(scrollYProgress, [0, 1], [0, 1]);

  return (
    <section className="relative py-24 md:py-32 bg-[#050507]" data-testid="why">
      <div className="pp-container">
        <SectionHeading overline="Why Us" title="Why Brands Choose PixelPapad" testid="why-heading" />

        <div ref={ref} className="relative pl-10 md:pl-16">
          {/* track */}
          <div className="absolute left-3 md:left-5 top-0 bottom-0 w-[2px] bg-white/8" />
          <motion.div style={{ scaleY: lineScale }}
            className="absolute left-3 md:left-5 top-0 bottom-0 w-[2px] origin-top"
            aria-hidden="true">
            <div className="h-full w-full" style={{ background: "linear-gradient(180deg,#f59e0b,#ec4899,#8b5cf6,#06b6d4)" }} />
          </motion.div>

          <div className="space-y-4">
            {WHY.map((w, i) => (
              <motion.div key={w}
                initial={{ opacity: 0, x: 40 }} whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.6, delay: (i % 4) * 0.05 }}
                className="group relative pp-card rounded-xl px-6 md:px-8 py-6 flex items-center gap-5 hover:translate-x-2"
                data-testid={`why-panel-${i}`}
              >
                <span className="absolute -left-[38px] md:-left-[54px] top-1/2 -translate-y-1/2 h-4 w-4 rounded-full bg-[#f59e0b] ring-4 ring-[#f59e0b]/20" />
                <span className="font-display text-3xl md:text-4xl text-white/20 group-hover:text-[#f59e0b] transition-colors tabular-nums">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-display uppercase text-xl md:text-2xl tracking-wide text-white">{w}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
